import { useCallback } from 'react';

export const useSmoothScroll = () => {
  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    // アニメーションを再トリガーするために、ページを再読み込み
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }, []);

  const scrollToElement = useCallback((elementId) => {
    // 同一ページ内でもページトップに移動してアニメーションを再生
    scrollToTop();
  }, [scrollToTop]);

  return { scrollToTop, scrollToElement };
};
